export const APP_VERSION = {
  version: '2.1.3',
  commit: '105cbb0',
  date: '2025-05-16T06:50:02.486Z'
};
